module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "replacePage",
    attrs: {
      "md-open-from": "#replacePage",
      "md-close-to": "#replacePage"
    },
    on: {
      "open": _vm.fixContent,
      "close": _vm.startOver
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "14px",
      "padding-bottom": "0px"
    }
  }, [_c('md-dialog-content', [_c('p', [_vm._v("Replace Page")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "replace-page-file"
    }
  }, [_vm._v("File")]), _vm._v(" "), _c('md-file', {
    key: _vm.fileInputKey,
    attrs: {
      "id": "replace-page-file",
      "required": "",
      "accept": "application/pdf"
    },
    on: {
      "selected": _vm.onReplacePageFileChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "from-to-wrap"
  }, [_c('div', {
    staticClass: "from-to"
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "replace-page-from"
    }
  }, [_vm._v("From ")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "replace-page-from",
      "type": "input",
      "readonly": ""
    },
    model: {
      value: (_vm.replacePageFrom),
      callback: function($$v) {
        _vm.replacePageFrom = $$v
      },
      expression: "replacePageFrom"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "replace-page-to"
    }
  }, [_vm._v("To ")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "replace-page-to",
      "type": "input",
      "readonly": ""
    },
    model: {
      value: (_vm.replacePageTo),
      callback: function($$v) {
        _vm.replacePageTo = $$v
      },
      expression: "replacePageTo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "comm-error"
  }, [(_vm.errorFromMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorFromMessage))]) : _vm._e(), _vm._v(" "), (_vm.errorToMessage) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorToMessage))]) : _vm._e()])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    staticStyle: {
      "margin-bottom": "25px"
    },
    on: {
      "click": _vm.replacePages
    }
  }, [_vm._v("Replace Page(s)")])], 1)], 1)])]), _vm._v(" "), _c('md-dialog', {
    ref: "savedDraftThumbnailDialog",
    on: {
      "close": _vm.savedDraftThumbnailDialogCloseOutside
    }
  }, [_c('md-dialog-content', {
    staticStyle: {
      "padding": "24px",
      "width": "800px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_vm._v("Warning, you are about to change the PDF for all users. This cannot be undone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                Cuelist recommends creating a backup before applying any changes.\n            ")]), _vm._v(" "), (_vm.project.autoSaveCap === true) ? _c('p', {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_vm._v("\n                Cuelist keeps your last 10 page-change saves.\n            ")]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "padding": "16px"
    }
  }, [_c('md-button', {
    staticClass: "md-default",
    on: {
      "click": _vm.savedDraftThumbnailDialogClose
    }
  }, [_vm._v("\n                Cancel\n            ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.onDialogClose('proceedWithoutSaving')
      }
    }
  }, [_vm._v("\n                Proceed Without Saving\n            ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": function($event) {
        return _vm.onDialogClose('saveAndContinue')
      }
    }
  }, [_vm._v("\n                Save & Continue\n            ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-915790d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/replace-page.vue
// module id = 1279
// module chunks = 21